import 'react-toastify/dist/ReactToastify.css';
import Allteacherstables from './Tables/overalldetailsallteachers';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import Highcharts from 'highcharts';
import HighchartsExportData from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsReact from 'highcharts-react-official';
import Ifcategory from './Tables/lfcategory';
import Milestone from './Tables/milestone';
import OverAllMetrics from './Tables/allmetics';
import OverallDetails from './Tables/Overall details';
import React, { useRef, useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import {
  Container,
  Nav,
  NavItem,
  NavLink,
  Card,
  CardBody,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Spinner,
} from 'reactstrap';
HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);

// Function to store selected items in sessionStorage
const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify([...value])); // Convert Set to array before storing
};
// // Function to load selected items from sessionStorage
const loadFromSessionStorage = (key) => {
  const savedData = sessionStorage.getItem(key);
  return savedData ? new Set(JSON.parse(savedData)) : new Set(); // Parse and convert back to Set
};
// Function to remove selected items from sessionStorage
const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};
const IndividualTeacherReport = () => {
  document.title = 'Linc Quality Hub';

  const location = useLocation();
  const navigate = useNavigate();
  const teacherName = location.state?.teacherName;

  // State Management
  const [universityDropdownOpen, setUniversityDropdownOpen] = useState(false);
  const [timelineDropdownOpen, setTimelineDropdownOpen] = useState(false);
  const [programDropdownOpen, setProgramDropdownOpen] = useState(false);
  const [milestoneDropdownOpen, setMilestoneDropdownOpen] = useState(false);
  const [milestonetypeDropdownOpen, setMilestonetypeDropdownOpen] =
    useState(false);

  const [assessmentDropdownOpen, setAssessmentDropdownOpen] = useState(false);
  const [termDropdownOpen, setTermDropdownOpen] = useState(false); // New state for term dropdown

  const [selectedUniversities, setSelectedUniversities] = useState(new Set());
  const [selectedTimelines, setSelectedTimelines] = useState(new Set());
  const [selectedTerms, setSelectedTerms] = useState(new Set()); // New state for selected terms
  const [selectedPrograms, setSelectedPrograms] = useState(new Set());
  const [selectedMilestones, setSelectedMilestones] = useState(new Set());
  const [selectedMilestonestype, setSelectedMilestonestype] = useState(
    new Set(),
  );
  const [selectedAssessments, setSelectedAssessments] = useState(new Set());

  const [appliedUniversities, setAppliedUniversities] = useState(new Set());
  const [appliedTimelines, setAppliedTimelines] = useState(new Set());
  const [appliedTerms, setAppliedTerms] = useState(new Set()); // New state for applied terms
  const [appliedPrograms, setAppliedPrograms] = useState(new Set()); // New state for applied terms
  const [appliedmilestonetype, setAppliedMilestonetype] = useState(new Set()); // New state for applied terms
  const [appliedmilestone, setAppliedMilestone] = useState(new Set());
  const [appliedAssessment, setAppliedAssesment] = useState(new Set());

  // // console.log("tq",teacherQcDetails)
  // State for fetched data
  const [universities, setUniversities] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [timelineYears, setTimelineYears] = useState([]);
  const [timelineTerms, setTimelineTerms] = useState([]); // To store timeline terms
  const [timelinePrograms, setTimelinePrograms] = useState([]);
  const [timelineMilestone, setTimelineMilestone] = useState([]);
  const [timelineMilestonetype, setTimelineMilestonetype] = useState([]);
  const [timelineAssesment, setTimelineAssesment] = useState([]);

  // Toggle functions
  const [teacherQcDetails, setTeacherQcDeatils] = useState([]);
  const [mentoredTeacher, setMentoredDeatails] = useState([]);
  const [allTeacher, setallDeatails] = useState([]);
  const [mentoredTeacherteacherSummary, setMentoredteacherSummaryDetails] =
    useState([]);

  // console.log("tq", teacherQcDetails)
  const [loading, setLoading] = useState(true); // New loading state
  const [loading1, setLoading1] = useState(false);

  //search option
  const [universitySearch, setUniversitySearch] = useState('');
  const [programSearch, setProgramSearch] = useState('');
  const [timelineSearch, setTimelineSearch] = useState('');
  const [termSearch, setTermSearch] = useState('');
  const [milestoneTypeSearch, setMilestoneTypeSearch] = useState('');
  const [milestoneSearch, setMilestoneSearch] = useState('');
  const [assessmentSearch, setAssessmentSearch] = useState('');
  const [isMentoredApplyClicked, setIsMentoredApplyClicked] = useState(false);
  const [loadingFilter, setLoadingFilters] = useState(false);
  //load filters in session stoarage
  useEffect(() => {
    setLoading(true);
    setAppliedUniversities(loadFromSessionStorage('appliedUniversities'));
    setAppliedPrograms(loadFromSessionStorage('appliedPrograms'));
    setAppliedTimelines(loadFromSessionStorage('appliedTimelinesteacherqc'));
    setAppliedTerms(loadFromSessionStorage('appliedTermsteacherqc'));
    setAppliedMilestonetype(
      loadFromSessionStorage('appliedmilestoetypeteacherqc'),
    );
    setAppliedMilestone(loadFromSessionStorage('appliedmilestoeteacherqc'));
    setAppliedAssesment(loadFromSessionStorage('appliedassesmentteacherqc'));

    // Handle teacherid directly if passed from another page
    setSelectedPrograms(loadFromSessionStorage('appliedPrograms'));
    setSelectedUniversities(loadFromSessionStorage('appliedUniversities'));
    setSelectedTimelines(loadFromSessionStorage('selectedTimelinesteacherqc'));
    setSelectedTerms(loadFromSessionStorage('selectedTermsteacherqc'));
    setSelectedMilestonestype(
      loadFromSessionStorage('selectedmilestonetypeteacherqc'),
    );
    setSelectedMilestones(loadFromSessionStorage('selectedmilestoneteacherqc'));
    setSelectedAssessments(
      loadFromSessionStorage('selectedAsessmentteacherqc'),
    );

    setLoading(false);
  }, []);
  const user_token = localStorage.getItem('usertoken');

  const handleSearchChange = (e, type) => {
    const value = e.target.value;
    switch (type) {
      case 'university':
        setUniversitySearch(value);
        break;
      case 'program':
        setProgramSearch(value);
        break;
      case 'timeline':
        setTimelineSearch(value);
        break;
      case 'term':
        setTermSearch(value);
        break;
      case 'milestoneType':
        setMilestoneTypeSearch(value);
        break;
      case 'milestone':
        setMilestoneSearch(value);
        break;
      case 'assessment':
        setAssessmentSearch(value);
      default:
        break;
    }
  };

  const filterUniversities = (universitySearch) => {
    return universities.filter((u) =>
      u.university_name.toLowerCase().includes(universitySearch.toLowerCase()),
    );
  };

  const filterPrograms = (programSearch) => {
    return programs.filter(([id, name]) =>
      name.toLowerCase().includes(programSearch.toLowerCase()),
    );
  };

  const filterTimeline = (timelineSearch) => {
    return timelineYears.filter((year) => year.includes(timelineSearch));
  };

  const filterTerms = (termSearch) => {
    return timelineTerms.filter((term) =>
      term.toLowerCase().includes(termSearch.toLowerCase()),
    );
  };
  const filterMilestoneTypes = (search) => {
    return timelineMilestonetype.filter((type) =>
      type.toLowerCase().includes(search.toLowerCase()),
    );
  };

  const filterMilestones = (search) => {
    return timelineMilestone.filter((milestone) =>
      milestone.toString().includes(search),
    );
  };

  const filterAssessments = (search) => {
    return timelineAssesment.filter((assessment) =>
      assessment.toLowerCase().includes(search.toLowerCase()),
    );
  };

  // // console.log("tec", teacherQcDetails)

  const toggleProgramDropdown = () => setProgramDropdownOpen((prev) => !prev);
  const toggleMilestoneDropdown = () =>
    setMilestoneDropdownOpen((prev) => !prev);
  const toggleAssessmentDropdown = () =>
    setAssessmentDropdownOpen((prev) => !prev);
  const toggleUniversityDropdown = () => {
    setUniversityDropdownOpen((prev) => !prev);
  };
  const toggleMilestonetypeDropdown = () =>
    setMilestonetypeDropdownOpen((prev) => !prev);

  const toggleTimelineDropdown = () => {
    setTimelineDropdownOpen((prev) => !prev);
  };
  const toggleTermDropdown = () => {
    setTermDropdownOpen((prev) => !prev); // Toggle term dropdown
  };

  const handleSelectItem = (
    item,
    selectedSet,
    setSelectedSet,
    toggleDropdown,
  ) => {
    let newSelection = new Set(selectedSet);

    // If the item is part of universities or programs (which allow multiple selections), handle accordingly
    if (
      item.removename === 'removeuniversity' ||
      item.removename === 'removeprograms'
    ) {
      // If the selected item is already chosen, allow deselection
      if (selectedSet.has(item.id)) {
        newSelection.delete(item.id);
      } else {
        newSelection.add(item.id);
      }
    } else if (
      item.removename === 'removeyears' ||
      item.removename === 'removestudyperiod' ||
      item.removename === 'removemilestone' ||
      item.removename === 'removemilestonetype' ||
      item.removename === 'removeassesment'
    ) {
      // If the item is part of year or study period (single selection)
      newSelection.clear(); // Clear all previous selections
      // newSelection.delete(item.id);
      newSelection.add(item.id); // Add the new selection
    }

    // Clear dependent selections when an item is deselected
    if (item.removename === 'removeuniversity') {
      setSelectedPrograms(new Set());
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setPrograms([]);
      setTimelineYears([]);
      setTimelineTerms([]);
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
      setSelectedMilestonestype(new Set());
      setTimelineMilestonetype([]);
      setSelectedAssessments(new Set());
      setTimelineAssesment([]);
    } else if (item.removename === 'removeprograms') {
      setSelectedTimelines(new Set());
      setSelectedTerms(new Set());
      setTimelineYears([]);
      setTimelineTerms([]);
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
      setSelectedMilestonestype(new Set());
      setTimelineMilestonetype([]);

      setSelectedAssessments(new Set());
      setTimelineAssesment([]);
    } else if (item.removename === 'removeyears') {
      setSelectedTerms(new Set());
      setTimelineTerms([]);
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
      setSelectedMilestonestype(new Set());
      setTimelineMilestonetype([]);
      setSelectedAssessments(new Set());
      setTimelineAssesment([]);
    } else if (item.removename === 'removestudyperiod') {
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
      setSelectedMilestonestype(new Set());
      setTimelineMilestonetype([]);
      setSelectedAssessments(new Set());
      setTimelineAssesment([]);
    } else if (item.removename === 'removemilestonetype') {
      setSelectedMilestones(new Set());
      setTimelineMilestone([]);
      setSelectedAssessments(new Set());
      setTimelineAssesment([]);
    } else if (item.removename === 'removemilestone') {
      setSelectedAssessments(new Set());
      setTimelineAssesment([]);
    }
    setSelectedSet(newSelection);
    toggleDropdown();
  };

  const isItemSelected = (itemId, selectedSet) => selectedSet.has(itemId);

  const handleSelectItemPrograms = (selectedProgram) => {
    const newSelection = new Set(selectedPrograms);
    if (newSelection.has(selectedProgram)) {
      newSelection.delete(selectedProgram);
    } else {
      newSelection.add(selectedProgram);
    }
    setSelectedPrograms(newSelection);
  };

  const handleSelectItemTimeLine = (selectedYear) => {
    const newSelection = new Set(selectedTimelines);
    if (newSelection.has(selectedYear)) {
      newSelection.delete(selectedYear);
    } else {
      newSelection.add(selectedYear);
    }
    setSelectedTimelines(newSelection);
  };

  const handleSelectItemTerm = (selectedTerm) => {
    const newSelection = new Set(selectedTerms);
    if (newSelection.has(selectedTerm)) {
      newSelection.delete(selectedTerm);
    } else {
      newSelection.add(selectedTerm);
    }
    setSelectedTerms(newSelection);
  };

  const isTimelineSelected = (selectedYear) =>
    selectedTimelines.has(selectedYear);
  const isTermSelected = (selectedTerm) => selectedTerms.has(selectedTerm);
  const ismilestonetypemSelected = (selectedMiletype) =>
    selectedMilestonestype.has(selectedMiletype);

  // const isUnitSelected = (selectedUnit) => selectedUnits.has(selectedUnit);
  const isProgramsSelected = (selectedProgram) =>
    selectedPrograms.has(selectedProgram);
  const ismilestoneSelected = (selectedMilestone) =>
    selectedMilestones.has(selectedMilestone);
  const isAssesmentSelected = (selectedAssessment) =>
    selectedAssessments.has(selectedAssessment);

  const handleSelectItemMilestonetype = (selectedMilestonetype) => {
    const newSelection = new Set(selectedMilestonestype);
    if (newSelection.has(selectedMilestonetype)) {
      newSelection.delete(selectedMilestonetype);
    } else {
      newSelection.add(selectedMilestonetype);
    }
    setSelectedMilestonestype(newSelection);
  };

  const handleSelectItemMilestone = (selectedMilestone) => {
    const newSelection = new Set(selectedMilestones);
    if (newSelection.has(selectedMilestone)) {
      newSelection.delete(selectedMilestone);
    } else {
      newSelection.add(selectedMilestone);
    }
    setSelectedMilestonestype(newSelection);
  };
  const handleSelectAssessment = (selectedAssessment) => {
    const newSelection = new Set(selectedAssessments);
    if (newSelection.has(selectedAssessment)) {
      newSelection.delete(selectedAssessment);
    } else {
      newSelection.add(selectedAssessment);
    }
    setSelectedMilestonestype(newSelection);
  };

  const handleSelectItem1 = (item, selectedSet, setter, toggleDropdown) => {
    const newSelection = new Set();

    // Always add the selected item (ID) to the selection set
    newSelection.add(item.id);

    setter(newSelection); // Update the state with the new single selection
    toggleDropdown(); // Optionally toggle the dropdown visibility
  };

  const handleApply = () => {
    // Check if both timelines and terms are selected
    // if (selectedTimelines.size > 0 && selectedTerms.size > 0) {
    //   toast.error("Please choose either a year or a term, not both.");
    //   return;
    // }
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }
    if (selectedPrograms.size === 0) {
      toast.error('Please choose a program.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a Term.');
      return;
    }

    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedPrograms(new Set(selectedPrograms));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelinesteacherqc', selectedTimelines);
    saveToSessionStorage('appliedTermsteacherqc', selectedTerms);
    saveToSessionStorage('appliedPrograms', selectedPrograms);

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('selectedTimelinesteacherqc', selectedTimelines);
    saveToSessionStorage('appliedPrograms', selectedPrograms);
    saveToSessionStorage('selectedTermsteacherqc', selectedTerms);

    saveToSessionStorage(
      'appliedmilestoetypeteacherqc',
      selectedMilestonestype,
    );
    saveToSessionStorage('appliedmilestoeteacherqc', selectedMilestones);
    saveToSessionStorage('appliedassesmentteacherqc', selectedAssessments);
    saveToSessionStorage(
      'selectedmilestonetypeteacherqc',
      selectedMilestonestype,
    );
    saveToSessionStorage('selectedmilestoneteacherqc', selectedMilestones);
    saveToSessionStorage('selectedAsessmentteacherqc', selectedAssessments);

    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setProgramDropdownOpen(false);
  };

  const handleApplyAllteachers = () => {
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a Term.');
      return;
    }
    if (selectedMilestonestype.size === 0) {
      toast.error('Please choose a Milestonetype.');
      return;
    }
    if (selectedMilestones.size === 0) {
      toast.error('Please choose a Milestone.');
      return;
    }
    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedPrograms(new Set(selectedPrograms));
    setAppliedMilestonetype(new Set(selectedMilestonestype));
    setAppliedMilestone(new Set(selectedMilestones));
    setAppliedAssesment(new Set(selectedAssessments));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelinesteacherqc', selectedTimelines);
    saveToSessionStorage('appliedTermsteacherqc', selectedTerms);
    saveToSessionStorage('appliedPrograms', selectedPrograms);

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('selectedTimelinesteacherqc', selectedTimelines);
    saveToSessionStorage('appliedPrograms', selectedPrograms);
    saveToSessionStorage('selectedTermsteacherqc', selectedTerms);

    saveToSessionStorage(
      'appliedmilestoetypeteacherqc',
      selectedMilestonestype,
    );
    saveToSessionStorage('appliedmilestoeteacherqc', selectedMilestones);
    saveToSessionStorage('appliedassesmentteacherqc', selectedAssessments);
    saveToSessionStorage(
      'selectedmilestonetypeteacherqc',
      selectedMilestonestype,
    );
    saveToSessionStorage('selectedmilestoneteacherqc', selectedMilestones);
    saveToSessionStorage('selectedAsessmentteacherqc', selectedAssessments);
    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setProgramDropdownOpen(false);
    setMilestonetypeDropdownOpen(false);
    setMilestoneDropdownOpen(false);
    // setAssessmentDropdownOpen(false);
  };

  const handleApplyMentored = () => {
    if (selectedUniversities.size === 0) {
      toast.error('Please choose a university.');
      return;
    }
    if (selectedTimelines.size === 0) {
      toast.error('Please choose a year.');
      return;
    }
    if (selectedTerms.size === 0) {
      toast.error('Please choose a Term.');
      return;
    }
    if (selectedMilestonestype.size === 0) {
      toast.error('Please choose a Milestonetype.');
      return;
    }
    if (selectedMilestones.size === 0) {
      toast.error('Please choose a Milestone.');
      return;
    }

    // Apply selections
    setAppliedUniversities(new Set(selectedUniversities));
    setAppliedTimelines(new Set(selectedTimelines));
    setAppliedTerms(new Set(selectedTerms));
    setAppliedPrograms(new Set(selectedPrograms));
    setAppliedMilestonetype(new Set(selectedMilestonestype));
    setAppliedMilestone(new Set(selectedMilestones));
    setAppliedAssesment(new Set(selectedAssessments));

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('appliedTimelinesteacherqc', selectedTimelines);
    saveToSessionStorage('appliedTermsteacherqc', selectedTerms);
    saveToSessionStorage('appliedPrograms', selectedPrograms);

    saveToSessionStorage('appliedUniversities', selectedUniversities);
    saveToSessionStorage('selectedTimelinesteacherqc', selectedTimelines);
    saveToSessionStorage('appliedPrograms', selectedPrograms);
    saveToSessionStorage('selectedTermsteacherqc', selectedTerms);

    saveToSessionStorage(
      'appliedmilestoetypeteacherqc',
      selectedMilestonestype,
    );
    saveToSessionStorage('appliedmilestoeteacherqc', selectedMilestones);
    saveToSessionStorage('appliedassesmentteacherqc', selectedAssessments);
    saveToSessionStorage(
      'selectedmilestonetypeteacherqc',
      selectedMilestonestype,
    );
    saveToSessionStorage('selectedmilestoneteacherqc', selectedMilestones);
    saveToSessionStorage('selectedAsessmentteacherqc', selectedAssessments);
    // Close all dropdowns
    setUniversityDropdownOpen(false);
    setTimelineDropdownOpen(false);
    setTermDropdownOpen(false);
    setProgramDropdownOpen(false);
    setMilestonetypeDropdownOpen(false);
    setMilestoneDropdownOpen(false);
    // setAssessmentDropdownOpen(false);
  };

  // State to manage the active tab
  const [activeTab, setActiveTab] = useState('tab2');

  // Function to handle tab change
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };
  const fetchDataTabs = async () => {
    try {
      const payload = {
        mode: 'tabs',
        // user_id: parseInt(uid)
      };

      // console.log("Sending tabs request with token:", user_token);  // 🔍
      // console.log("Payload:", payload);

      const tabResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'personnel/',
        payload,
        {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        },
      );
      localStorage.setItem('tabs', JSON.stringify(tabResponse.data));

      // console.log("Tabs Response:", tabResponse);
    } catch (error) {
      // console.log('Error fetching tab data:', error);
    }
  };

  useEffect(() => {
    fetchDataTabs();
  }, []);

  const fetchData = async () => {
    try {
      setLoadingFilters(true);
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setUniversities(response.universities || []); // Ensure we set to an empty array if undefined
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingFilters(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedUniversities && selectedUniversities.size > 0) {
      fetchDataPrograms();
    }
  }, [selectedUniversities]);

  const fetchDataPrograms = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        mode: 'metrics',
        sub_mode: 'program',
        // milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setPrograms(unitResponse.program || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log('Error fetching unit data:', error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0
    ) {
      fetchDataYear();
    }
  }, [selectedUniversities, selectedPrograms]);

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (selectedTimelines || selectedTerms) {
    }
  }, [selectedTimelines, selectedTerms]);

  const fetchDataYear = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        mode: 'teacher_qc',
        sub_mode: 'year',
        // milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      setTimelineYears(unitResponse.year || []);
      // setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0
    ) {
      fetchDataTerm();
    }
  }, [selectedUniversities, selectedPrograms, selectedTimelines]);

  const fetchDataTerm = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        mode: 'teacher_qc',
        sub_mode: 'term',
        // milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // setTimelineYears(unitResponse.year || []);
      setTimelineTerms(unitResponse.terms || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0
    ) {
      fetchDataMileStonetype();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);

  const fetchDataMileStonetype = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,

        mode: 'teacher_qc',
        sub_mode: 'milestone_type',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestonetype(unitResponse.milestone_types || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedMilestonestype.size > 0
    ) {
      fetchDataMileStone();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
    selectedMilestonestype,
  ]);

  const fetchDataMileStone = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        milestone_type:
          selectedMilestonestype.size > 0
            ? Array.from(selectedMilestonestype)[0]
            : null,

        mode: 'teacher_qc',
        sub_mode: 'milestone',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // setTimelineYears(unitResponse.year || []);
      setTimelineMilestone(unitResponse.milestone || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };
  useEffect(() => {
    // Call fetchData only if there are selected universities or timelines
    if (
      selectedUniversities &&
      selectedUniversities.size > 0 &&
      selectedPrograms.size > 0 &&
      selectedTimelines.size > 0 &&
      selectedTerms.size > 0 &&
      selectedMilestonestype.size > 0 &&
      selectedMilestones.size > 0
    ) {
      fetchDataAssessment();
    }
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
    selectedMilestonestype,
    selectedMilestones,
  ]);

  const fetchDataAssessment = async () => {
    try {
      const payload = {
        university:
          selectedUniversities.size > 0
            ? Array.from(selectedUniversities)
            : null,
        program:
          selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,
        year: selectedTimelines.size > 0 ? Array.from(selectedTimelines) : null,
        term: selectedTerms.size > 0 ? Array.from(selectedTerms) : null,
        milestone_type:
          selectedMilestonestype.size > 0
            ? Array.from(selectedMilestonestype)[0]
            : null,
        milestone_number:
          selectedMilestones.size > 0
            ? Array.from(selectedMilestones)[0]
            : null,

        mode: 'teacher_qc',
        sub_mode: 'assessment',
        //  milestone_number: "Milestone 1"
      };

      const unitResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + 'filter/',
        payload,
        {
          headers: {
            Authorization: 'Token ' + user_token,
          },
        },
      );

      // setTimelineYears(unitResponse.year || []);
      setTimelineAssesment(unitResponse.assessment || []);
    } catch (error) {
      // console.log("Error fetching unit data:", error);
    }
  };

  // refresh states
  const resetData = () => {
    setTeacherQcDeatils([]); // Extract values and set
    setMentoredDeatails([]);
  };
  const resetDatamilestoneallteacher = () => {
    setallDeatails([]);
  };
  const resetDatamilestonementoredteacher = () => {
    setMentoredteacherSummaryDetails([]);
  };

  useEffect(() => {
    if (selectedUniversities && selectedUniversities.size > 0) {
      const fetchDataTeacherQc = async () => {
        try {
          // if (
          //   appliedUniversities.size === 0 &&
          //   appliedPrograms.size === 0 &&
          //   appliedTimelines.size === 0 &&
          //   appliedTerms.size === 0
          // ) {
          //   console.warn('No filters applied; skipping API call.');
          //   return;
          // }
          // const hasMilestoneData = selectedMilestones.size > 0 || selectedMilestonestype.size > 0;
          // const hasOtherFilters =
          //   appliedUniversities.size > 0 ||
          //   appliedTimelines.size > 0 ||
          //   appliedTerms.size > 0 ||
          //   appliedPrograms.size > 0;

          // if (!hasMilestoneData && !hasOtherFilters) {
          //   return; // Exit early if all filters are empty
          // }

          // // Set loaders based on conditions
          // if (hasMilestoneData) {
          //   setLoading(true); // Show screen loader if milestone data exists
          // }

          // if (!hasMilestoneData && hasOtherFilters) {
          //   setLoading1(true); // Show table loader only if milestone is empty
          // }

          const payload = {
            university:
              selectedUniversities.size > 0
                ? Array.from(appliedUniversities)
                : null,
            program:
              selectedPrograms.size > 0 ? Array.from(selectedPrograms) : null,

            year:
              selectedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
            term: selectedTerms.size > 0 ? Array.from(appliedTerms) : null,
            // milestone_number: "Milestone 1"
          };
          let config = {
            headers: {
              Authorization: `Token ${user_token}`,
            },
          };
          const responseteach = await axios.post(
            process.env.REACT_APP_API_BASE_URL + 'teacher_qc/',
            payload,
            config
          );
          // setTeacherQcDeatils(responseteach.teacher_details); // Set the data after fetching
          setTeacherQcDeatils(Object.values(responseteach.all_teachers)); // Extract values and set
          setMentoredDeatails(Object.values(responseteach.mentored));
          if (responseteach.status === 500) {
            resetData();
          }
          // setLoading(true);
        } catch (error) {
          console.error('Error fetching data:', error);
          // toast.error('Please Try Another Filters')
          resetData();
        } finally {
          // setLoading(false);
          // setLoading1(false);
        }
      };
      fetchDataTeacherQc();
    }
  }, [appliedUniversities, appliedPrograms, appliedTimelines, appliedTerms]);

  useEffect(() => {
    // if (selectedUniversities && selectedUniversities.size > 0) {
    // if (

    //   appliedmilestone.size === 0 &&
    //   appliedmilestonetype.size === 0
    // ) {
    //   console.warn('No filters applied; skipping API call.');
    //   return;
    // }
    const fetchDataTeacherQcAllteacheres = async () => {
      try {
        const hasMilestoneData =
          selectedMilestones.size > 0 || selectedMilestonestype.size > 0;
        const hasOtherFilters =
          appliedUniversities.size > 0 ||
          appliedTimelines.size > 0 ||
          appliedTerms.size > 0 ||
          appliedPrograms.size > 0;

        if (!hasMilestoneData && !hasOtherFilters) {
          return; // Exit early if all filters are empty
        }

        // Set loaders based on conditions
        if (hasMilestoneData) {
          setLoading(true); // Show screen loader if milestone data exists
        }

        if (!hasMilestoneData && hasOtherFilters) {
          setLoading1(true); // Show table loader only if milestone is empty
        }

        const payload = {
          university:
            selectedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null,
          program:
            selectedPrograms.size > 0 ? Array.from(appliedPrograms) : null,

          year:
            selectedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
          term: selectedTerms.size > 0 ? Array.from(appliedTerms) : null,
          milestone_type:
            selectedMilestonestype.size > 0
              ? Array.from(appliedmilestonetype)[0]
              : null,
          milestone_number:
            selectedMilestones.size > 0
              ? Array.from(appliedmilestone)[0]
              : null,
          assessment_type:
            selectedAssessments.size > 0
              ? Array.from(appliedAssessment)[0]
              : null,

          mode: 'teacher_metrics',
          sub_mode: 'all',
          // milestone_number: "Milestone 1"
        };
        let config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };
        const responseteach = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'teacher_qc/',
          payload,
          config
        );
        // setTeacherQcDeatils(responseteach.teacher_details); // Set the data after fetching
        // setTeacherQcDeatils(Object.values(responseteach.all_teachers)); // Extract values and set
        setallDeatails(responseteach.teacher_metrics);

        if (responseteach.status === 500) {
          resetDatamilestoneallteacher();
        }
      } catch (error) {
        console.error('Error fetching data:', error);

        resetDatamilestoneallteacher();
      } finally {
        setLoading(false);
        setLoading1(false);
      }
    };
    fetchDataTeacherQcAllteacheres();
    // }
  }, [
    appliedUniversities,
    appliedPrograms,
    appliedTimelines,
    appliedTerms,
    appliedPrograms,
    appliedmilestonetype,
    appliedmilestone,
    appliedAssessment,
  ]);

  useEffect(() => {
    // setLoading(true);
    // if (selectedUniversities && selectedUniversities.size > 0) {
    // if (

    //   appliedmilestone.size === 0 &&
    //   appliedmilestonetype.size === 0
    // ) {
    //   console.warn('No filters applied; skipping API call.');
    //   return;
    // }
    const fetchDataTeacherQcMentoredteacheres = async () => {
      try {
        // const hasMilestoneData = selectedMilestones.size > 0 || selectedMilestonestype.size > 0;
        // const hasOtherFilters =
        //   appliedUniversities.size > 0 ||
        //   appliedTimelines.size > 0 ||
        //   appliedTerms.size > 0 ||
        //   appliedPrograms.size > 0;

        // if (!hasMilestoneData && !hasOtherFilters) {
        //   return; // Exit early if all filters are empty
        // }

        // // Set loaders based on conditions
        // if (hasMilestoneData) {
        //   setLoading(true); // Show screen loader if milestone data exists
        // }

        // if (!hasMilestoneData && hasOtherFilters) {
        //   setLoading1(true); // Show table loader only if milestone is empty
        // }

        const payload = {
          university:
            selectedUniversities.size > 0
              ? Array.from(appliedUniversities)
              : null,
          program:
            selectedPrograms.size > 0 ? Array.from(appliedPrograms) : null,

          year:
            selectedTimelines.size > 0 ? Array.from(appliedTimelines) : null,
          term: selectedTerms.size > 0 ? Array.from(appliedTerms) : null,
          milestone_type:
            selectedMilestonestype.size > 0
              ? Array.from(appliedmilestonetype)[0]
              : null,
          milestone_number:
            selectedMilestones.size > 0
              ? Array.from(appliedmilestone)[0]
              : null,
          assessment_type:
            selectedAssessments.size > 0
              ? Array.from(appliedAssessment)[0]
              : null,

          mode: 'teacher_metrics',
          sub_mode: 'mentored',
          // milestone_number: "Milestone 1"
        };
        let config = {
          headers: {
            Authorization: `Token ${user_token}`,
          },
        };
        const responseteach = await axios.post(
          process.env.REACT_APP_API_BASE_URL + 'teacher_qc/',
          payload,
          config
        );
        // setTeacherQcDeatils(responseteach.teacher_details); // Set the data after fetching
        // setTeacherQcDeatils(Object.values(responseteach.all_teachers)); // Extract values and set
        setMentoredteacherSummaryDetails(responseteach.teacher_metrics);
        if (responseteach.status === 500) {
          resetDatamilestonementoredteacher();
        }
        // setLoading(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        resetDatamilestonementoredteacher();
      } finally {
        //  setLoading(false);
        //  setLoading1(false);
      }
    };
    fetchDataTeacherQcMentoredteacheres();
    // }
  }, [
    appliedUniversities,
    appliedPrograms,
    appliedTimelines,
    appliedTerms,
    appliedPrograms,
    appliedmilestonetype,
    appliedmilestone,
    appliedAssessment,
  ]);

  // // console.log("dataall",allTeacher)
  // sticky filter bar
  // sticky filter bar
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY; // Current scroll position
      const threshold = 100; // Adjust this value as needed
      setIsSticky(scrollY > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to update selected filters
  const handleSelectionChange = (type, value) => {
    const updatedSet = new Set(type);
    if (updatedSet.has(value)) {
      updatedSet.delete(value);
    } else {
      updatedSet.add(value);
    }
    return updatedSet;
  };

  const [slideIndex, setSlideIndex] = useState(0);
  const slideWidth = 300; // Adjust this based on your filter tag size

  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [showScrollButtonsmilestone, setShowScrollButtonsmilestone] =
    useState(false);

  const checkOverflow = () => {
    if (filterSummaryRef.current) {
      setShowScrollButtons(
        filterSummaryRef.current.scrollWidth >
        filterSummaryRef.current.clientWidth,
      );
    }
  };
  //mile stone
  const checkOverflowMilestone = () => {
    if (filterSummaryRefmilestone.current) {
      setShowScrollButtonsmilestone(
        filterSummaryRefmilestone.current.scrollWidth >
        filterSummaryRefmilestone.current.clientWidth,
      );
    }
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflow);
  }, [
    selectedUniversities,
    selectedPrograms,
    selectedTimelines,
    selectedTerms,
  ]);
  //milestone
  useEffect(() => {
    checkOverflowMilestone();
    window.addEventListener('resize', checkOverflowMilestone); // Recheck on window resize
    return () => window.removeEventListener('resize', checkOverflowMilestone);
  }, [selectedMilestonestype, selectedMilestones, selectedAssessments]);

  // Function to handle the left scroll button click
  const handleLeftClick = () => {
    if (filterSummaryRef.current) {
      const newScrollLeft = Math.max(
        filterSummaryRef.current.scrollLeft - 200,
        0,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  //milestone
  const handleLeftClickMilestone = () => {
    if (filterSummaryRefmilestone.current) {
      const newScrollLeft = Math.max(
        filterSummaryRefmilestone.current.scrollLeft - 200,
        0,
      );
      filterSummaryRefmilestone.current.scrollLeft = newScrollLeft;
    }
  };
  // Function to handle the right scroll button click
  const handleRightClick = () => {
    if (filterSummaryRef.current) {
      const maxScrollLeft =
        filterSummaryRef.current.scrollWidth -
        filterSummaryRef.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRef.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRef.current.scrollLeft = newScrollLeft;
    }
  };
  const handleRightClickMilestone = () => {
    if (filterSummaryRefmilestone.current) {
      const maxScrollLeft =
        filterSummaryRefmilestone.current.scrollWidth -
        filterSummaryRefmilestone.current.clientWidth;
      const newScrollLeft = Math.min(
        filterSummaryRefmilestone.current.scrollLeft + 200,
        maxScrollLeft,
      );
      filterSummaryRefmilestone.current.scrollLeft = newScrollLeft;
    }
  };

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const filterSummaryRef = useRef(null);

  // Start dragging (onMouseDown)
  const startDrag = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDragging(true);
    setStartX(clientX);
    setScrollLeft(filterSummaryRef.current.scrollLeft);
    filterSummaryRef.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRef.current.scrollLeft = scrollLeft - distance;
  };

  const stopDrag = () => {
    setIsDragging(false);
    filterSummaryRef.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  const [isDraggingmilestone, setIsDraggingmilestone] = useState(false);
  const [startXmilestone, setStartXmilestone] = useState(0);
  const [scrollLeftmilestone, setScrollLeftmilestone] = useState(0);

  const filterSummaryRefmilestone = useRef(null);

  // Start dragging (onMouseDown)
  const startDragmilestone = (e) => {
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    setIsDraggingmilestone(true);
    setStartXmilestone(clientX);
    setScrollLeftmilestone(filterSummaryRefmilestone.current.scrollLeft);
    filterSummaryRefmilestone.current.style.cursor = 'grabbing'; // Change the cursor for desktop
    document.body.style.userSelect = 'none'; // Disable text selection globally
  };

  const handleMouseMovemilestone = (e) => {
    if (!isDraggingmilestone) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const distance = clientX - startX;
    filterSummaryRefmilestone.current.scrollLeft = scrollLeft - distance;
  };

  const stopDragMilestone = () => {
    setIsDraggingmilestone(false);
    filterSummaryRefmilestone.current.style.cursor = 'grab';
    document.body.style.userSelect = ''; // Re-enable text selection globally
  };

  //fileter deleted selection
  const hasSelections =
    selectedUniversities.size > 0 ||
    selectedPrograms.size > 0 ||
    selectedTimelines.size > 0 ||
    selectedTerms.size > 0;
  // selectedMilestonestype.size > 0 ||
  // selectedMilestones.size > 0;

  const clearAllSelections = () => {
    setSelectedUniversities(new Set());
    setSelectedPrograms(new Set());
    setSelectedTimelines(new Set());
    setSelectedTerms(new Set());
    // setSelectedMilestonestype(new Set());
    // setSelectedMilestones(new Set())
    setPrograms([]);
    setTimelineYears([]);
    setTimelineTerms([]);
    removeFromSessionStorage('appliedUniversitiesteacherqc');
    removeFromSessionStorage('appliedProgramsteacherqc');
    removeFromSessionStorage('appliedTimelinesteacherqc');
    removeFromSessionStorage('appliedTermsteacherqc');
    removeFromSessionStorage('appliedmilestoetypeteacherqc');
    removeFromSessionStorage('appliedmilestoeteacherqc');
    removeFromSessionStorage('appliedassesmentteacherqc');

    removeFromSessionStorage('selectedProgramsteacherqc');
    removeFromSessionStorage('selectedUniversitiesteacherqc');
    removeFromSessionStorage('selectedTimelinesteacherqc');
    removeFromSessionStorage('selectedTermsteacherqc');
    removeFromSessionStorage('selectedmilestonetypeteacherqc');
    removeFromSessionStorage('selectedmilestoneteacherqc');
    removeFromSessionStorage('selectedAsessmentteacherqc');
    fetchData();

    resetData();
    resetDatamilestonementoredteacher();
    resetDatamilestoneallteacher();
  };
  //milestone clear selction
  const hasSelectionsmilestone =
    selectedMilestonestype.size > 0 ||
    selectedMilestones.size > 0 ||
    selectedAssessments > 0;

  const clearAllSelectionsmilestone = () => {
    setSelectedMilestonestype(new Set());
    setSelectedMilestones(new Set());
    setSelectedAssessments(new Set());
    removeFromSessionStorage('appliedmilestoetypeteacherqc');
    removeFromSessionStorage('appliedmilestoeteacherqc');
    removeFromSessionStorage('appliedassesmentteacherqc');
    removeFromSessionStorage('selectedmilestonetypeteacherqc');
    removeFromSessionStorage('selectedmilestoneteacherqc');
    removeFromSessionStorage('selectedAsessmentteacherqc');
    fetchData();
  };
  return (
    <React.Fragment>
      <div className="page-content px-0">
        <Container fluid={true}>
          {/* Navigation Bar */}
          <div className={`top-filter  ${isSticky ? 'sticky-filter' : ''}`}>
            <div className="">
              {/* <div className="tab-tp-title">
                  <h3 className="bold">Staff Overview</h3>
                </div> */}
              <div className="metrics mt-2 d-flex flex-sm-row flex-column gap-2 justify-content-between">
                <div className="d-flex justify-content-end   gap-2">
                  {/* University Dropdown */}
                  <Dropdown
                    isOpen={universityDropdownOpen}
                    toggle={toggleUniversityDropdown}
                  >
                    <DropdownToggle
                      className={`btn uni-bg ${universityDropdownOpen ? '' : ' '
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      {/* University <i className="mdi mdi-chevron-down" /> */}
                      {loadingFilter ? 'Loading' : 'University'}{' '}
                      <i className="mdi mdi=chevron-down" />
                    </DropdownToggle>
                    {!loadingFilter && (
                      <>
                        <DropdownMenu className="p-0">
                          <input
                            type="text"
                            placeholder="Search Universities"
                            className="form-control"
                            value={universitySearch}
                            onChange={(e) =>
                              handleSearchChange(e, 'university')
                            }
                          />

                          {/* "Select All" Option */}
                          <DropdownItem
                            onClick={(e) => {
                              e.stopPropagation();
                              const allSelected =
                                selectedUniversities.size ===
                                universities.length;
                              const newSelection = new Set();

                              if (!allSelected) {
                                // Select all universities
                                universities.forEach((university) =>
                                  newSelection.add(university.id),
                                );
                                setSelectedPrograms(new Set()); // Clear selected programs
                                setPrograms([]); // Reset program list
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setTimelineYears([]);
                                setTimelineTerms([]);
                              } else {
                                // Deselect all universities, applying the removeuniversity logic
                                setSelectedPrograms(new Set()); // Clear selected programs
                                setPrograms([]); // Reset program list
                                setSelectedTimelines(new Set());
                                setSelectedTerms(new Set());
                                setTimelineYears([]);
                                setTimelineTerms([]);
                              }

                              setSelectedUniversities(newSelection); // Update the selected universities set
                              toggleUniversityDropdown(); // Close the dropdown
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={
                                  selectedUniversities.size ===
                                  universities.length
                                } // Check if all are selected
                                readOnly
                              />
                              <label className="form-check-label">All</label>
                            </div>
                          </DropdownItem>

                          {/* University Options */}
                          {filterUniversities(universitySearch).map(
                            (university) => (
                              <DropdownItem
                                key={university.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSelectItem(
                                    {
                                      id: university.id,
                                      name: university.university_name,
                                      removename: 'removeuniversity',
                                    },
                                    selectedUniversities,
                                    setSelectedUniversities,
                                    toggleUniversityDropdown,
                                  );
                                }}
                              >
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={isItemSelected(
                                      university.id,
                                      selectedUniversities,
                                    )}
                                    readOnly
                                  />
                                  <label className="form-check-label">
                                    {university.university_name}
                                  </label>
                                </div>
                              </DropdownItem>
                            ),
                          )}
                        </DropdownMenu>
                      </>
                    )}
                  </Dropdown>

                  {/* Programs Dropdown */}
                  <Dropdown
                    isOpen={programDropdownOpen}
                    toggle={toggleProgramDropdown}
                  >
                    <DropdownToggle
                      disabled={programs.length === 0}
                      className={`btn program-bg ${programs.length > 0 ? '' : 'disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Programs <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Programs"
                        className="form-control"
                        value={programSearch}
                        onChange={(e) => handleSearchChange(e, 'program')}
                      />

                      {/* All Option */}
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          const allSelected =
                            selectedPrograms.size === programs.length;
                          const newSelection = new Set();
                          if (!allSelected) {
                            programs.forEach(([programId]) =>
                              newSelection.add(programId),
                            );
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());
                            setTimelineYears([]);
                            setTimelineTerms([]);
                          } else {
                            //deselect
                            setSelectedTimelines(new Set());
                            setSelectedTerms(new Set());

                            setTimelineYears([]);
                            setTimelineTerms([]);
                          }
                          setSelectedPrograms(newSelection);
                          toggleProgramDropdown();
                        }}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedPrograms.size === programs.length}
                            readOnly
                          />
                          <label className="form-check-label">All</label>
                        </div>
                      </DropdownItem>

                      {/* Program Options */}
                      {filterPrograms(programSearch).map(
                        ([programId, programName]) => (
                          <DropdownItem
                            key={programId}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSelectItem(
                                {
                                  id: programId,
                                  name: programName,
                                  removename: 'removeprograms',
                                },
                                selectedPrograms,
                                setSelectedPrograms,
                                toggleProgramDropdown,
                              );
                            }}
                          >
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isItemSelected(
                                  programId,
                                  selectedPrograms,
                                )}
                                readOnly
                              />
                              <label className="form-check-label">
                                {programName}
                              </label>
                            </div>
                          </DropdownItem>
                        ),
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <div className="d-flex justify-content-end flex-wrap gap-2">
                  {/* Timeline Dropdown */}
                  <Dropdown
                    isOpen={timelineDropdownOpen}
                    toggle={toggleTimelineDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineYears.length === 0}
                      className={`btn year-bg ${timelineYears.length > 0 ? '' : ' disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Year <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Year"
                        className="form-control"
                        value={timelineSearch}
                        onChange={(e) => handleSearchChange(e, 'timeline')}
                      />
                      {/* "Select All" Option */}
                      {/* <DropdownItem onClick={(e) => {
                            e.stopPropagation();
                            const allSelected = selectedTimelines.size === timelineYears.length;
                            const newSelection = new Set();

                            if (!allSelected) {
                              // Select all years
                              timelineYears.forEach(year => newSelection.add(year));
                              setSelectedTerms(new Set());
                              setTimelineTerms([]);
                            } else {
                              setSelectedTerms(new Set());
                              setTimelineTerms([]);
                            }
                            setSelectedTimelines(newSelection);
                            toggleTimelineDropdown();
                          }}>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedTimelines.size === timelineYears.length}
                                readOnly
                              />
                              <label className="form-check-label">All</label>
                            </div>
                          </DropdownItem> */}
                      {/* {timelineYears.map((year, index) => ( */}
                      {filterTimeline(timelineSearch).map((year, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: year,
                                name: year,
                                removename: 'removeyears',
                              },
                              selectedTimelines,
                              setSelectedTimelines,
                              toggleTimelineDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isItemSelected(year, selectedTimelines)}
                              readOnly
                            />
                            <label className="form-check-label">{year}</label>
                          </div>
                        </DropdownItem>
                      ))}

                      {/* ))} */}
                    </DropdownMenu>
                  </Dropdown>

                  {/* Timeline Term Dropdown */}
                  <Dropdown
                    isOpen={termDropdownOpen}
                    toggle={toggleTermDropdown}
                  >
                    <DropdownToggle
                      disabled={timelineTerms.length === 0}
                      className={`btn stu-period-bg ${timelineTerms.length > 0 ? '' : ' disable'
                        }`}
                      caret
                      style={{ color: '#656565' }}
                    >
                      Study Period <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="p-0">
                      <input
                        type="text"
                        placeholder="Search Study Period"
                        className="form-control"
                        value={termSearch}
                        onChange={(e) => handleSearchChange(e, 'term')}
                      />
                      {/* "Select All" Option */}
                      {/* <DropdownItem onClick={(e) => {
                          e.stopPropagation();
                          const allSelected = selectedTerms.size === timelineTerms.length;
                          const newSelection = new Set();

                          if (!allSelected) {
                            // Select all terms
                            timelineTerms.forEach(term => newSelection.add(term));
                          }
                          setSelectedTerms(newSelection);
                          toggleTermDropdown();
                        }}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedTerms.size === timelineTerms.length}
                              readOnly
                            />
                            <label className="form-check-label">All</label>
                          </div>
                        </DropdownItem> */}
                      {/* {timelineTerms.map((term, index) => ( */}
                      {filterTerms(termSearch).map((term, index) => (
                        <DropdownItem
                          key={index}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelectItem(
                              {
                                id: term,
                                name: term,
                                removename: 'removestudyperiod',
                              },
                              selectedTerms,
                              setSelectedTerms,
                              toggleTermDropdown,
                            );
                          }}
                        >
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isTermSelected(term, selectedTerms)}
                              readOnly
                            />
                            <label className="form-check-label">{term}</label>
                          </div>
                        </DropdownItem>
                      ))}

                      {/* ))} */}
                    </DropdownMenu>
                  </Dropdown>

                  <button
                    type="button"
                    className="btn btn-primary border-0 py-1 px-3 me-1"
                    onClick={handleApply}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>

            {/* normal nav filter show */}
            <div className="filters-show">
              <div className="selected-filters">
                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-left"
                    onClick={handleLeftClick}
                  >
                    <i className="ri-arrow-left-s-line"></i>
                  </button>
                )}

                <div
                  className="filter-summary"
                  ref={filterSummaryRef}
                  onMouseDown={startDrag}
                  onMouseMove={handleMouseMove}
                  onMouseUp={stopDrag}
                  onMouseLeave={stopDrag}
                  onTouchStart={startDrag} // Touch equivalent of onMouseDown
                  onTouchMove={handleMouseMove} // Touch equivalent of onMouseMove
                  onTouchEnd={stopDrag} // Touch equivalent of onMouseUp
                >
                  {selectedUniversities.size > 0 && (
                    <div
                      className={`filter-item ${showScrollButtons ? 'ft-pl' : ''
                        }`}
                    >
                      {Array.from(selectedUniversities).map((universityId) => {
                        const university = universities.find(
                          (u) => u.id === universityId,
                        );
                        return university ? (
                          <p
                            key={universityId}
                            className="filter-tag university"
                          >
                            {university.university_name}{' '}
                            {/* <i
                                className="ri-close-line"
                                style={{ cursor: "pointer" }}
                                onClick={() => removeUniversity(universityId)}
                              ></i> */}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedPrograms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedPrograms).map((programId) => {
                        const program = programs.find(
                          ([id]) => id === programId,
                        );
                        return program ? (
                          <p key={programId} className="filter-tag programs">
                            {program[1]}
                          </p>
                        ) : null;
                      })}
                    </div>
                  )}

                  {selectedTimelines.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTimelines).map((year, index) => (
                        <p key={index} className="filter-tag year">
                          {year}
                        </p>
                      ))}
                    </div>
                  )}

                  {selectedTerms.size > 0 && (
                    <div className="filter-item">
                      {Array.from(selectedTerms).map((term, index) => (
                        <p key={index} className="filter-tag stu-period">
                          {term}
                        </p>
                      ))}
                    </div>
                  )}
                </div>

                {showScrollButtons && (
                  <button
                    className="slider-button slider-button-right"
                    onClick={handleRightClick}
                  >
                    <i className="ri-arrow-right-s-line"></i>
                  </button>
                )}
              </div>
              <div className="">
                {hasSelections && (
                  <button
                    type="button"
                    className="clear-all-btn me-1"
                    onClick={clearAllSelections}
                  >
                    <i class="ri-close-fill"></i> Clear All
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="tab-tp-title">
            <h3 className="bold">Staff Overview</h3>
          </div>

          <div className="ind-teacher-report-tab mt-1">
            <Nav className="mb-0" tabs>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab2' ? 'active' : ''}
                  active={activeTab === 'tab2'}
                  onClick={() => toggleTab('tab2')}
                  style={{ cursor: 'pointer', marginRight: '3px' }}
                >
                  All Staff
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab1' ? 'active' : ''}
                  active={activeTab === 'tab1'}
                  onClick={() => toggleTab('tab1')}
                  style={{ cursor: 'pointer', marginRight: '2px' }}
                >
                  Mentored Staff
                </NavLink>
              </NavItem>
            </Nav>

            <div>
              {activeTab === 'tab1' && (
                <div>
                  <div>
                    <Card className="mb-2" style={{ borderTopLeftRadius: '0' }}>
                      <CardBody className="switch-tab-scroll">
                        <div>
                          <div className="d-md-flex  align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Staff Summary</h5>
                            </div>
                          </div>
                          {loading1 ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <div className="mt-2">
                              <OverallDetails
                                mentoredTeacher={mentoredTeacher}
                                appliedUniversities={appliedUniversities}
                                appliedTimelines={appliedTimelines}
                                appliedTerms={appliedTerms}
                                appliedPrograms={appliedPrograms}
                                selectedUniversities={appliedUniversities}
                              />
                            </div>
                          )}
                        </div>

                        <div className="mt-4">
                          {/* <div className="d-md-flex  align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Teacher Metrics</h5>
                              <ErrorOutlineRoundedIcon /><span>Please select "Milestone # and Assessment # to view pefroemance metrics specific to that milestone and assessment</span>
                            </div>
                          </div> */}

                          <div className="d-md-flex align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Key Performance Metrics</h5>
                              <div className="d-flex">
                                <ErrorOutlineRoundedIcon
                                  style={{
                                    fontSize: '1rem',
                                    marginRight: '2.5px',
                                    marginTop: '2px',
                                  }}
                                  aria-hidden="true"
                                />{' '}
                                <span>
                                  Select Milestone Type , Milestone and
                                  Assessment to View Performance Metrics.
                                </span>
                              </div>
                            </div>

                            <div className="d-flex justify-content-end flex-lg-nowrap flex-wrap gap-2">
                              {/* Milestone Dropdown */}
                              <Dropdown
                                isOpen={milestonetypeDropdownOpen}
                                toggle={toggleMilestonetypeDropdown}
                              >
                                <DropdownToggle
                                  className={`btn border-0 mi-stone-type-bg ${timelineMilestonetype.length > 0
                                    ? ''
                                    : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000', border: 'none' }}
                                >
                                  Milestone Type
                                  <span className="mandatory">*</span>{' '}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineMilestonetype.map((milestone, index) => ( */}
                                  {/* Search Box */}
                                  {/* <input
                                    type="text"
                                    placeholder="Search Milestone Type"
                                    className="form-control"
                                    value={milestoneTypeSearch}
                                    onChange={(e) => handleSearchChange(e, 'milestoneType')}
                                  /> */}
                                  {filterMilestoneTypes(
                                    milestoneTypeSearch,
                                  ).map((milestone, index) => (
                                    <DropdownItem
                                      key={index}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSelectItem(
                                          {
                                            id: milestone,
                                            name: milestone,
                                            removename: 'removemilestonetype',
                                          },
                                          selectedMilestonestype,
                                          setSelectedMilestonestype,
                                          toggleMilestonetypeDropdown,
                                        );
                                      }}
                                    >
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={ismilestonetypemSelected(
                                            milestone,
                                            selectedMilestonestype,
                                          )}
                                          readOnly
                                        />
                                        <label className="form-check-label">
                                          {milestone}
                                        </label>
                                      </div>
                                    </DropdownItem>
                                  ))}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>
                              {/* Milestone Dropdown */}
                              <Dropdown
                                isOpen={milestoneDropdownOpen}
                                toggle={toggleMilestoneDropdown}
                              >
                                <DropdownToggle
                                  className={`btn border-0 mi-stone-bg ${timelineMilestone.length > 0
                                    ? ''
                                    : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000' }}
                                >
                                  Milestone<span className="mandatory">*</span>{' '}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineMilestone.map((milestone, index) => ( */}
                                  {/* Search Box */}
                                  <input
                                    type="text"
                                    placeholder="Search Milestone"
                                    className="form-control"
                                    value={milestoneSearch}
                                    onChange={(e) =>
                                      handleSearchChange(e, 'milestone')
                                    }
                                  />
                                  {filterMilestones(milestoneSearch).map(
                                    (milestone, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSelectItem(
                                            {
                                              id: milestone,
                                              name: milestone,
                                              removename: 'removemilestone',
                                            },
                                            selectedMilestones,
                                            setSelectedMilestones,
                                            toggleMilestoneDropdown,
                                          );
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={ismilestoneSelected(
                                              milestone,
                                              selectedMilestones,
                                            )}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            {milestone}
                                          </label>
                                        </div>
                                      </DropdownItem>
                                    ),
                                  )}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>

                              {/* Assessment Dropdown */}
                              <Dropdown
                                isOpen={assessmentDropdownOpen}
                                toggle={toggleAssessmentDropdown}
                              >
                                <DropdownToggle
                                  className={`btn border-0 assest-bg ${timelineAssesment.length > 0
                                    ? ''
                                    : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000' }}
                                >
                                  Assessments{' '}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineAssesment.map((assessment, index) => ( */}
                                  {/* Search Box */}
                                  <input
                                    type="text"
                                    placeholder="Search Assessment"
                                    className="form-control"
                                    value={assessmentSearch}
                                    onChange={(e) =>
                                      handleSearchChange(e, 'assessment')
                                    }
                                  />
                                  {filterAssessments(assessmentSearch).map(
                                    (assessment, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSelectItem(
                                            {
                                              id: assessment,
                                              name: assessment,
                                              removename: 'removeassesment',
                                            },
                                            selectedAssessments,
                                            setSelectedAssessments,
                                            toggleAssessmentDropdown,
                                          );
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={isAssesmentSelected(
                                              assessment,
                                              selectedAssessments,
                                            )}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            {assessment}
                                          </label>
                                        </div>
                                      </DropdownItem>
                                    ),
                                  )}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>
                              <button
                                type="button"
                                className="btn btn-primary border-0 py-1 px-3 me-1"
                                onClick={handleApplyMentored}
                              >
                                Apply
                              </button>
                            </div>
                          </div>

                          {/* filter tags start -  filter show */}
                          <div className="filters-show">
                            <div className="selected-filters">
                              {showScrollButtonsmilestone && (
                                <button
                                  className="slider-button slider-button-left"
                                  onClick={handleLeftClickMilestone}
                                >
                                  <i className="ri-arrow-left-s-line"></i>
                                </button>
                              )}

                              <div
                                className="filter-summary"
                                ref={filterSummaryRefmilestone}
                                onMouseDown={startDragmilestone}
                                onMouseMove={handleMouseMovemilestone}
                                onMouseUp={stopDragMilestone}
                                onMouseLeave={stopDragMilestone}
                                onTouchStart={startDragmilestone} // Touch equivalent of onMouseDown
                                onTouchMove={handleMouseMovemilestone} // Touch equivalent of onMouseMove
                                onTouchEnd={stopDragMilestone} // Touch equivalent of onMouseUp
                              >
                                {selectedMilestonestype.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedMilestonestype).map(
                                      (milestone, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag mi-stone-type"
                                        >
                                          {milestone}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                                {selectedMilestones.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedMilestones).map(
                                      (milestone, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag mi-stone"
                                        >
                                          {milestone}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                                {selectedAssessments.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedAssessments).map(
                                      (assessment, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag assest"
                                        >
                                          {assessment}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>

                              {showScrollButtonsmilestone && (
                                <button
                                  className="slider-button slider-button-right"
                                  onClick={handleRightClickMilestone}
                                >
                                  <i className="ri-arrow-right-s-line"></i>
                                </button>
                              )}
                            </div>

                            <div className="">
                              {hasSelectionsmilestone && (
                                <button
                                  type="button"
                                  className="clear-all-btn me-1"
                                  onClick={clearAllSelectionsmilestone}
                                >
                                  <i class="ri-close-fill"></i> Clear All
                                </button>
                              )}
                            </div>
                          </div>

                          {/* filter tags end */}

                          {loading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <div className="mt-2">
                              <Ifcategory
                                mentoredTeacherteacherSummary={
                                  mentoredTeacherteacherSummary
                                }
                                appliedUniversities={appliedUniversities}
                                appliedTimelines={appliedTimelines}
                                appliedTerms={appliedTerms}
                                appliedPrograms={appliedPrograms}
                                selectedUniversities={appliedUniversities}

                              />
                            </div>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              )}
              {activeTab === 'tab2' && (
                <div>
                  <div>
                    <Card>
                      <CardBody className="switch-tab-scroll">
                        <div>
                          <div className="d-md-flex  align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Staff Summary</h5>
                            </div>
                          </div>

                          {loading1 ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <div className="mt-2">
                              <Allteacherstables
                                teacherQcDetails={teacherQcDetails}
                                appliedUniversities={appliedUniversities}
                                appliedTimelines={appliedTimelines}
                                appliedTerms={appliedTerms}
                                appliedPrograms={appliedPrograms}
                              />
                            </div>
                          )}
                        </div>

                        {/* <div className="mt-4">
                          <div className="d-md-flex  align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Over All Metrics</h5>
                            </div>
                          </div>
                          <div className="mt-2">
                            <OverAllMetrics />
                          </div>
                        </div> */}

                        <div className="mt-4">
                          <div className="d-md-flex align-items-center">
                            <div className="flex-grow-1 mb-md-0 mb-2">
                              <h5 className="f-16 bold">Key Performance Metrics</h5>
                              <div className="d-flex">
                                <ErrorOutlineRoundedIcon
                                  style={{
                                    fontSize: '1rem',
                                    marginRight: '2.5px',
                                    marginTop: '3px',
                                  }}
                                  aria-hidden="true"
                                />{' '}
                                <span>
                                  Select Milestone Type , Milestone and
                                  Assessment to View Performance Metrics.
                                </span>
                              </div>
                            </div>
                            <div className="d-flex justify-content-end flex-lg-nowrap flex-wrap gap-2">
                              {/* Milestone Dropdown */}
                              <Dropdown
                                isOpen={milestonetypeDropdownOpen}
                                toggle={toggleMilestonetypeDropdown}
                              >
                                <DropdownToggle
                                  disabled={timelineMilestonetype.length === 0}
                                  className={`btn border-0 mi-stone-type-bg ${timelineMilestonetype.length > 0
                                    ? ''
                                    : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000' }}
                                >
                                  Milestone Type
                                  <span className="mandatory">*</span>{' '}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineMilestonetype.map((milestone, index) => ( */}
                                  {/* Search Box */}
                                  {/* <input
                                    type="text"
                                    placeholder="Search Milestone Type"
                                    className="form-control"
                                    value={milestoneTypeSearch}
                                    onChange={(e) => handleSearchChange(e, 'milestoneType')}
                                  /> */}
                                  {filterMilestoneTypes(
                                    milestoneTypeSearch,
                                  ).map((milestone, index) => (
                                    <DropdownItem
                                      key={index}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSelectItem(
                                          {
                                            id: milestone,
                                            name: milestone,
                                            removename: 'removemilestonetype',
                                          },
                                          selectedMilestonestype,
                                          setSelectedMilestonestype,
                                          toggleMilestonetypeDropdown,
                                        );
                                      }}
                                    >
                                      <div className="form-check">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          checked={ismilestonetypemSelected(
                                            milestone,
                                            selectedMilestonestype,
                                          )}
                                          readOnly
                                        />
                                        <label className="form-check-label">
                                          {milestone}
                                        </label>
                                      </div>
                                    </DropdownItem>
                                  ))}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>
                              {/* Milestone Dropdown */}
                              <Dropdown
                                isOpen={milestoneDropdownOpen}
                                toggle={toggleMilestoneDropdown}
                              >
                                <DropdownToggle
                                  disabled={timelineMilestone.length === 0}
                                  className={`btn border-0 mi-stone-bg ${timelineMilestone.length > 0
                                    ? ''
                                    : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000' }}
                                >
                                  Milestone<span className="mandatory">*</span>{' '}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineMilestone.map((milestone, index) => ( */}
                                  {/* Search Box */}
                                  <input
                                    type="text"
                                    placeholder="Search Milestone"
                                    className="form-control"
                                    value={milestoneSearch}
                                    onChange={(e) =>
                                      handleSearchChange(e, 'milestone')
                                    }
                                  />
                                  {filterMilestones(milestoneSearch).map(
                                    (milestone, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSelectItem(
                                            {
                                              id: milestone,
                                              name: milestone,
                                              removename: 'removemilestone',
                                            },
                                            selectedMilestones,
                                            setSelectedMilestones,
                                            toggleMilestoneDropdown,
                                          );
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={ismilestoneSelected(
                                              milestone,
                                              selectedMilestones,
                                            )}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            {milestone}
                                          </label>
                                        </div>
                                      </DropdownItem>
                                    ),
                                  )}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>

                              {/* Assessment Dropdown */}
                              <Dropdown
                                isOpen={assessmentDropdownOpen}
                                toggle={toggleAssessmentDropdown}
                              >
                                <DropdownToggle
                                  disabled={timelineAssesment.length === 0}
                                  className={`btn border-0 assest-bg ${timelineAssesment.length > 0
                                    ? ''
                                    : ' disable'
                                    }`}
                                  caret
                                  style={{ color: '#000' }}
                                >
                                  Assessments{' '}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="p-0">
                                  {/* {timelineAssesment.map((assessment, index) => ( */}
                                  {/* Search Box */}
                                  <input
                                    type="text"
                                    placeholder="Search Assessment"
                                    className="form-control"
                                    value={assessmentSearch}
                                    onChange={(e) =>
                                      handleSearchChange(e, 'assessment')
                                    }
                                  />
                                  {filterAssessments(assessmentSearch).map(
                                    (assessment, index) => (
                                      <DropdownItem
                                        key={index}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSelectItem(
                                            {
                                              id: assessment,
                                              name: assessment,
                                              removename: 'removeassesment',
                                            },
                                            selectedAssessments,
                                            setSelectedAssessments,
                                            toggleAssessmentDropdown,
                                          );
                                        }}
                                      >
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={isAssesmentSelected(
                                              assessment,
                                              selectedAssessments,
                                            )}
                                            readOnly
                                          />
                                          <label className="form-check-label">
                                            {assessment}
                                          </label>
                                        </div>
                                      </DropdownItem>
                                    ),
                                  )}

                                  {/* ))} */}
                                </DropdownMenu>
                              </Dropdown>
                              <button
                                type="button"
                                className="btn btn-primary border-0 py-1 px-3 me-1"
                                onClick={handleApplyAllteachers}
                              >
                                Apply
                              </button>
                            </div>
                          </div>

                          {/* filter tags start here */}

                          <div className="filters-show">
                            <div className="selected-filters">
                              {showScrollButtonsmilestone && (
                                <button
                                  className="slider-button slider-button-left"
                                  onClick={handleLeftClickMilestone}
                                >
                                  <i className="ri-arrow-left-s-line"></i>
                                </button>
                              )}

                              <div
                                className="filter-summary"
                                ref={filterSummaryRefmilestone}
                                onMouseDown={startDragmilestone}
                                onMouseMove={handleMouseMovemilestone}
                                onMouseUp={stopDragMilestone}
                                onMouseLeave={stopDragMilestone}
                                onTouchStart={startDragmilestone} // Touch equivalent of onMouseDown
                                onTouchMove={handleMouseMovemilestone} // Touch equivalent of onMouseMove
                                onTouchEnd={stopDragMilestone} // Touch equivalent of onMouseUp
                              >
                                {selectedMilestonestype.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedMilestonestype).map(
                                      (milestone, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag mi-stone-type"
                                        >
                                          {milestone}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                                {selectedMilestones.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedMilestones).map(
                                      (milestone, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag mi-stone"
                                        >
                                          {milestone}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                                {selectedAssessments.size > 0 && (
                                  <div className="filter-item">
                                    {Array.from(selectedAssessments).map(
                                      (assessment, index) => (
                                        <p
                                          key={index}
                                          className="filter-tag assest"
                                        >
                                          {assessment}
                                        </p>
                                      ),
                                    )}
                                  </div>
                                )}
                              </div>

                              {showScrollButtonsmilestone && (
                                <button
                                  className="slider-button slider-button-right"
                                  onClick={handleRightClickMilestone}
                                >
                                  <i className="ri-arrow-right-s-line"></i>
                                </button>
                              )}
                            </div>

                            <div className="">
                              {hasSelectionsmilestone && (
                                <button
                                  type="button"
                                  className="clear-all-btn me-1"
                                  onClick={clearAllSelectionsmilestone}
                                >
                                  <i class="ri-close-fill"></i> Clear All
                                </button>
                              )}
                            </div>
                          </div>

                          {/* filter tags end here */}

                          {loading ? ( // Show loader while loading
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: '200px' }}
                            >
                              <Spinner
                                style={{ width: '3rem', height: '3rem' }}
                              />
                            </div>
                          ) : (
                            <div className="mt-2">
                              <Milestone allTeacher={allTeacher}
                                appliedUniversities={appliedUniversities}
                                appliedTimelines={appliedTimelines}
                                appliedTerms={appliedTerms}
                                appliedPrograms={appliedPrograms}
                                selectedUniversities={appliedUniversities}
                              />
                            </div>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  );
};

export default IndividualTeacherReport;
